import React from 'react';

const CroTextAreaPrint = ({ text, label }) => (
    <div className="textarea_print">
        <label>{label}</label>
        <div className="textarea_text">
            {text}
        </div>
        <hr className='dotted' />
    </div>

);

export default CroTextAreaPrint;